<template>
  <div class="right-menu-content position-relative d-flex justify-content-end h-100 w-100">
    <div class="right-menu py-6 pl-3 d-none d-lg-block">

      <router-link to="/packages">
        <div class="card text-center animation">
          <div class="card-body">
          <span class="b-avatar text-primary" style="width: 45px; height: 45px;">

            <span class="b-avatar-custom ">
                 <feather-icon icon="ShoppingBagIcon" size="27"/>
            </span>
          </span>
            <div class="truncate">
              <span>Мобипакеты</span>
            </div>
          </div>
        </div>
      </router-link>

      <div class="card text-center" v-b-modal.modal-saved @click="Saved">
        <div class="card-body">
          <span class="b-avatar text-primary"
                badge
                badge-variant="success"
                badge-left
                badge-top
                style="width: 45px; height: 45px;">
            <span class="b-avatar-custom">
                <feather-icon icon="BookmarkIcon" size="27"/>
            </span>
          </span>
          <div class="truncate">
            <span>Сохраненные</span>
          </div>
        </div>
      </div>

      <div class="card text-center" @click="modalBooking">
        <div class="card-body">
          <span class="b-avatar text-primary" style="width: 45px; height: 45px;">
            <span class="b-avatar-custom">
                <feather-icon icon="LayersIcon" size="27"/>
            </span>
          </span>
          <div class="truncate">
            <span>Мои заказы</span>
          </div>
        </div>
      </div>

    </div>

    <div class="bottom-menu d-lg-none d-xl-none w-100 p-1">
      <b-row>
        <b-col cols="4" class="text-center cursor-pointer position-relative" @click="goPackages">
          <feather-icon icon="ShoppingBagIcon" class="text-primary" size="25"/>
          <span class="d-block w-100">Мобипакеты</span>
          <span class="m-animation"></span>
        </b-col>
        <b-col cols="4" class="text-center" v-b-modal.modal-saved @click="Saved">
          <feather-icon icon="BookmarkIcon" class="text-primary" size="25"/>
          <span class="d-block w-100">Сохраненные</span>
        </b-col>
        <b-col cols="4" class="text-center" @click="modalBooking">
          <feather-icon icon="LayersIcon" class="text-primary" size="25"/>
          <span class="d-block w-100">Мои заказы</span>
        </b-col>
      </b-row>
    </div>

    <!-- modal Saved -->
    <b-modal
      id="modal-saved"
      centered
      title="Сохраненные номера"
      ok-title="Закрыть"
      ok-variant="outline-secondary"
      ok-only
      size="lg"
    >
      <b-row>
        <Number :custom-class="'col-6 col-md-4'" @onSaved="Saved" v-for="(value, key) in saved" :key="key"
                :data="value" :msisdn="key" :price="value.level_price"
                :category="value.level_name" @modalOrder="modalOrder"/>
        <div class="col-12" v-if="Object.keys(saved).length==0">
          Тут пусто... &#128578;
        </div>

      </b-row>
    </b-modal>

    <OrderNumbers ref="orderModal"/>

    <!-- modal Booking -->
    <b-modal
      id="modal-booking"
      ref="modal-booking"
      scrollable
      centered
      title="Мои заказы"
      cancel-title="Закрыть"
      cancel-variant="outline-secondary"
    >
      <app-collapse
        type="margin"
        class="w-100"
        accordion
      >
      <app-collapse-item :title="`${key} (${value.dateAndTime})`" v-for="(value, key) in myOrders" :key="key" :data="value">
        <b-list-group class="mb-1">
          <b-list-group-item class="active">
           <b>Персональные данные</b>
          </b-list-group-item>
          <b-list-group-item class="">
            <b-row>
              <b-col cols="12" md="6" lg="6">
               Номер:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                 <b>{{key}}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                ФИО:
              </b-col>
              <b-col cols="12" md="6" lg="6">
               <b>{{value.fio}}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Контактный номер:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                 <b>{{value.clientPhoneNumber}}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>

        <b-list-group class="mb-2" v-if="value.address">
          <b-list-group-item class="active">
            <b>Доставка</b>
          </b-list-group-item>
          <b-list-group-item class="">
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Адрес:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b>{{value.address}}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>

        <b-list-group v-if="value.selfiePassport || value.passportA || value.passportB">
          <b-list-group-item class="active">
            <b>Онлайн регистрация</b>
          </b-list-group-item>
          <b-list-group-item v-if="value.selfiePassport">
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Фото с паспортом (Селфи):
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b>Загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item v-if="value.passportA">
            <b-row>
              <b-col cols="12" md="6" lg="6">
               Паспорт (Строна А):
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b>Загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item v-if="value.passportB">
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Паспорт (Строна B):
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b>Загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </app-collapse-item>
      </app-collapse>
      <div class="col-12" v-if="Object.keys(myOrders).length == 0">
        Тут пусто... &#128578;
      </div>
    </b-modal>
  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import Number from '@/views/frontend/components/numbers/components/Number.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import OrderNumbers from '@/views/frontend/components/OrderNumber.vue'

export default {
  name: 'RightMenu',
  components: {
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BModal,
    Number,
    OrderNumbers,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      saved: [],
      booking: 'Мои заказы',
      myOrders: {},
    }
  },
  props: {
    main: Function,
  },
  created() {
    this.Saved()
    this.MyOrders()
  },
  // updated() {
  //   this.Saved()
  //   this.MyOrders()
  // },
  watch() {
  },
  methods: {
    modalBooking() {
      this.MyOrders()
      this.$refs['modal-booking'].show()
    },
    modalOrder(msisdn, category, price) {
      this.$refs.orderModal.showModal(msisdn, category, price)
    },
    Saved(msisdn) {
      if (this.main && msisdn) {
        this.saved = VueCookies.get('saved')
        this.main(msisdn)
      }
    },
    MyOrders() {
      if (VueCookies.get('orders')) {
        this.myOrders = VueCookies.get('orders')
      } else {
        this.myOrders = {}
      }
    },
    goPackages() {
      this.$router.push({ name: 'packages' })
    },
  },
}
</script>

<style scoped>
.right-menu {
  width: 190px;
  background-color: #f7f6fc;
  border-top-left-radius: 3rem;
  border-bottom-left-radius: 3rem;
  font-size: 13px;
}

.bottom-menu {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1040;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, .1);
}

.right-menu:before {
  content: '';
  width: 150px;
  z-index: -1;
  position: absolute;
  top: 0;
  right: -50%;
  bottom: 0;
  background-color: #f7f6fc;
}

.right-menu .card{
  border-radius: 2.5rem;
  width: 125px;
  height: 125px;
}

.right-menu .card:hover {
  box-shadow: 0 0px 4px 0 rgba(34, 41, 47, 0.1) !important;
}

.right-menu .card-body {
  padding: 2.2rem 1rem;
}

.py-6 {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}
.animation{
  box-shadow: 0 0 0 rgba(115,103,240, 0.4);
  animation: pulse 2s infinite;
}
.m-animation{
  position: absolute;
  top: -2px;
  right: 41%;
  width: 10px;
  height: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  background: #2d2e9b;
  box-shadow: 0 0 0 0 rgba(115,103,240, 0.4);
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(115,103,240, 0.4);
    box-shadow: 0 0 0 0 rgba(115,103,240, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(115,103,240, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
    box-shadow: 0 0 0 0 rgba(115,103,240, 0);
  }
}

</style>
